import {
  estimateRetailServingPrice,
  getRetailServingDetails,
  formatCurrency,
} from "@sellar-io/common";
import { H6, InputContainer, InputNumber } from "@sellar-io/components";
import {
  StockListResponseType,
  SupplierGetResponseType,
} from "@sellar-io/api-v2/types";
import { useState } from "react";
import { useForm } from "react-hook-form";

export const PriceCalculator = ({
  product,
  supplier,
}: {
  product: StockListResponseType[number]["Products"][number];
  supplier: SupplierGetResponseType | undefined;
}) => {
  const { register } = useForm({
    defaultValues: {
      percentage: 0,
    },
    shouldUseNativeValidation: true,
  });
  const [sellingPrice, setSellingPrice] = useState(0);
  const [profit, setProfit] = useState<number>(0);
  const { isDraught: isCaskOrKeg, servings } = getRetailServingDetails(product);
  const profitAmount = (percentage: number) => {
    const estimate = estimateRetailServingPrice({
      priceExVat: product.ProductPriceTier?.price ?? 0,
      vatPercentage: supplier?.vatPercentage ?? 0,
      grossProfitMarginPercentage: supplier ? percentage : 0,
      servings,
    });
    setProfit(estimate.profitAfterVat);
    setSellingPrice(estimate.sellingPrice);
  };

  if (!supplier) return null;
  return (
    <>
      <div className="rounded-lg border">
        <div className="grid w-full grid-cols-6 border-b-1 p-2">
          <H6 className={"col-span-4"}>Gross profit margin (%)</H6>
          <InputContainer className={"col-span-2 items-end"}>
            <InputNumber
              className={"w-full"}
              {...register("percentage", { required: false })}
              onChange={(e) => profitAmount(parseFloat(e.target.value))}
              max={100}
            />
          </InputContainer>
        </div>
        <div className="border-bottom grid w-full grid-cols-6 border-gray-400 p-2">
          <H6 className={"col-span-4"}>Selling Price:</H6>
          <div className={"col-span-2 flex justify-end"}>
            <p>{formatCurrency(sellingPrice)}</p>
          </div>
        </div>
        <div className="grid w-full grid-cols-6 p-2">
          <H6 className={"col-span-4"}>
            Profit per {isCaskOrKeg ? "pint" : product.containerType} after VAT
          </H6>
          <div className={"col-span-2 flex justify-end"}>
            <p>{formatCurrency(profit)}</p>
          </div>
        </div>
      </div>
    </>
  );
};
